import CaseDecisionMapper from "../../caseDecisions/service/CaseDecisionMapper";
import CasePhase from "../model/CasePhase";
import CourtCase from "../model/CourtCase";

const CasePhaseMapper = (item: any) => {
  if (item && item.courtCase) {
    let courtCase = CourtCaseMapper(item.courtCase);
    item.courtCase = courtCase;
  }
  return CasePhase(item);
};
const CourtCaseMapper = (item: any) => {
  let decisions = item?.decisions?.map(CaseDecisionMapper) || [];
  let phases = item?.phases?.map(CasePhaseMapper) || [];
  if (item) {
    item.decisions = decisions;
    item.phases = phases;
  }
  let courtCase = CourtCase(item);
  return courtCase;
};

export default CourtCaseMapper;
